import { render, staticRenderFns } from "./endIndex.vue?vue&type=template&id=2a59ab27&scoped=true&"
import script from "./endIndex.vue?vue&type=script&lang=js&"
export * from "./endIndex.vue?vue&type=script&lang=js&"
import style0 from "./endIndex.vue?vue&type=style&index=0&id=2a59ab27&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a59ab27",
  null
  
)

export default component.exports